var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCached = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.833 6.667 12.5 10H15c0 2.758-2.242 5-5 5a4.894 4.894 0 0 1-2.334-.583L6.45 15.633A6.608 6.608 0 0 0 10 16.667 6.665 6.665 0 0 0 16.666 10h2.5l-3.333-3.333zM5 10c0-2.758 2.241-5 5-5 .841 0 1.641.208 2.333.583l1.217-1.216A6.61 6.61 0 0 0 10 3.333 6.665 6.665 0 0 0 3.333 10h-2.5l3.333 3.334L7.5 10H5z"
})));
export default SvgCached;